import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Library, Upload, ArrowRight } from "lucide-react";
import { API } from "../lib/api";

const CTA_TEXT =
  "Carica i tuoi libri, troveranno presto una nuova casa! E se hai il PDF dell'anno scorso, puoi selezionarli da lì";

/**
 * Contatore pubblico dei libri attualmente caricati sulla piattaforma.
 * variant="dashboard" -> pulsante che porta al caricamento (/i-miei-libri)
 * variant="landing"   -> pulsante che porta alla registrazione (onCta)
 */
export const BooksCountCard = ({ variant = "dashboard", onCta }) => {
  const [total, setTotal] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/books/count`)
      .then((r) => setTotal(r.data.total ?? 0))
      .catch(() => setTotal(0));
  }, []);

  const isLanding = variant === "landing";
  const ctaLabel = isLanding
    ? "Registrati e carica i tuoi libri"
    : "Carica i tuoi libri";

  return (
    <div
      className="bg-[#BFDBFE] border-4 border-[#0A0A0A] rounded-xl p-6 md:p-8 shadow-[8px_8px_0px_#0A0A0A]"
      data-testid="books-count-card"
    >
      <div className="flex flex-col md:flex-row md:items-center gap-6">
        <div className="flex items-center gap-4 md:flex-shrink-0">
          <div className="w-16 h-16 bg-[#FFFFFF] border-2 border-[#0A0A0A] rounded-full flex items-center justify-center shadow-[4px_4px_0px_#0A0A0A] flex-shrink-0">
            <Library size={28} className="text-[#0A0A0A]" />
          </div>
          <div className="leading-none">
            <span
              className="block text-5xl md:text-6xl font-black text-[#0A0A0A]"
              data-testid="books-count-number"
            >
              {total === null ? "—" : total.toLocaleString("it-IT")}
            </span>
            <span className="block mt-1 text-sm font-bold uppercase tracking-wide text-[#0A0A0A]">
              {total === 1 ? "libro disponibile" : "libri disponibili"}
            </span>
          </div>
        </div>

        <div className="flex-1">
          <p
            className="text-base md:text-lg font-medium text-[#0A0A0A] leading-relaxed mb-4"
            data-testid="books-count-cta-text"
          >
            {CTA_TEXT}
          </p>
          {isLanding ? (
            <button
              onClick={onCta}
              className="inline-flex items-center gap-2 bg-[#0A0A0A] text-[#FDFBF7] border-2 border-[#0A0A0A] font-bold uppercase tracking-wide px-6 py-3 text-sm shadow-[4px_4px_0px_#0A0A0A] hover:bg-gray-900 transition-transform active:translate-y-1 active:translate-x-1 active:shadow-none"
              data-testid="books-count-cta-btn"
            >
              <Upload size={18} />
              {ctaLabel}
              <ArrowRight size={18} />
            </button>
          ) : (
            <Link
              to="/i-miei-libri"
              className="inline-flex items-center gap-2 bg-[#0A0A0A] text-[#FDFBF7] border-2 border-[#0A0A0A] font-bold uppercase tracking-wide px-6 py-3 text-sm shadow-[4px_4px_0px_#0A0A0A] hover:bg-gray-900 transition-transform active:translate-y-1 active:translate-x-1 active:shadow-none"
              data-testid="books-count-cta-btn"
            >
              <Upload size={18} />
              {ctaLabel}
              <ArrowRight size={18} />
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default BooksCountCard;
